<div
  class="d-flex"
  [ngClass]="{ 'align-chips-start': alignLeft, 'flex-wrap': !noWrap }"
>
  <div *ngIf="roleCodes" class="role-chip-list" [ngClass]="{ 'role-chip-list-wrap': !noWrap }">
    <mat-chip-row
      *ngFor="let item of filteredRoles; let i = index"
      class="role"
      [matTooltip]="getTooltip(item)"
      [matTooltipDisabled]="false"
    >
      {{ item.code }}
    </mat-chip-row>
  </div>
  <div *ngIf="userNames && !roleCodes" class="role-chip-list" [ngClass]="{ 'role-chip-list-wrap': !noWrap }">
    <mat-chip-row class="role">
      {{ userNames }}
    </mat-chip-row>
  </div>
</div>
